// SPDX-License-Identifier: SEE LICENSE
import { useState, type FormEvent } from 'react';

import { useAuth } from '../auth';

export function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await login(username.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
      setPassword('');
    } finally {
      setBusy(false);
    }
  };

  const field: React.CSSProperties = {
    width: '100%',
    boxSizing: 'border-box',
    fontSize: 14,
    color: '#e8f2f1',
    background: 'rgba(9,16,26,0.7)',
    border: '1px solid rgba(120,160,160,0.22)',
    borderRadius: 10,
    padding: '11px 14px',
    outline: 'none',
    fontFamily: 'inherit',
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
        background:
          'radial-gradient(1100px 520px at 50% -10%, rgba(20,222,205,0.08), transparent 60%), #04090f',
        color: '#cfe0e0',
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: '100%',
          maxWidth: 380,
          background: 'rgba(9,16,26,0.72)',
          border: '1px solid rgba(120,160,160,0.16)',
          borderRadius: 18,
          padding: '34px 30px 30px',
          boxShadow: '0 30px 80px -30px rgba(0,0,0,0.8), 0 0 60px -30px rgba(20,222,205,0.25)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, marginBottom: 26 }}>
          <img
            src="/retronics-logo.jpeg"
            alt="Retronics"
            style={{
              width: 56,
              height: 56,
              borderRadius: 14,
              objectFit: 'contain',
              border: '1px solid rgba(20,222,205,0.4)',
              background: 'rgba(20,222,205,0.07)',
              boxShadow: '0 0 26px -6px rgba(20,222,205,0.6)',
            }}
          />
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 17, fontWeight: 600, letterSpacing: 1, color: '#f4faf9' }}>RETRONICS</div>
            <div style={{ fontSize: 10.5, letterSpacing: 2, color: '#6f878e', fontWeight: 600, marginTop: 4 }}>
              LIVE DIAGNOSTIC ENGINE
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <label style={{ fontSize: 11, letterSpacing: 1, color: '#8aa0a6', fontWeight: 600 }}>
            USERNAME
            <input
              style={{ ...field, marginTop: 6 }}
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              required
            />
          </label>
          <label style={{ fontSize: 11, letterSpacing: 1, color: '#8aa0a6', fontWeight: 600 }}>
            PASSWORD
            <input
              style={{ ...field, marginTop: 6 }}
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
        </div>

        {error && (
          <div
            style={{
              marginTop: 14,
              fontSize: 12.5,
              color: '#f5b5b0',
              background: 'rgba(240,106,94,0.1)',
              border: '1px solid rgba(240,106,94,0.35)',
              borderRadius: 9,
              padding: '9px 12px',
            }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={busy}
          style={{
            marginTop: 20,
            width: '100%',
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: 0.6,
            color: '#04090f',
            background: busy ? 'rgba(20,222,205,0.5)' : 'linear-gradient(180deg,#2ff0db,#14ddc9)',
            border: 'none',
            borderRadius: 11,
            padding: '12px 16px',
            cursor: busy ? 'default' : 'pointer',
            fontFamily: 'inherit',
            boxShadow: '0 0 24px -6px rgba(20,222,205,0.7)',
            transition: 'opacity 150ms',
          }}
        >
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <div style={{ marginTop: 18, textAlign: 'center', fontSize: 10.5, letterSpacing: 0.6, color: '#516068' }}>
          Authorized personnel only · access is logged
        </div>
      </form>
    </div>
  );
}
